import {
   SWITCH_VIEW,
   OPEN_NEW_FLOW_DIALOG,
   CLOSE_NEW_FLOW_DIALOG,
   CREATE_NEW_FLOW_FROM_PORTAL,
   FETCH_PORTAL_FLOWS,
   SET_IS_LOADING_PORTAL_FLOWS,
   FETCH_WORKFLOW_ACTIVITIES,
   FETCH_ANALYTICS_ACTIVITIES,
   ADD_PORTAL_FLOW,
   SET_OWNED_SHARED_FLOWS,
   SHARE_PORTAL_FLOW,
   FETCH_PORTAL_USER_FLOWS,
   SET_PORTAL_USER_FLOWS,
   OPEN_SHARER_FLOW_DIALOG,
   CLOSE_SHARER_FLOW_DIALOG,
   OPEN_SHAREE_FLOW_DIALOG,
   CLOSE_SHAREE_FLOW_DIALOG,
   SET_CREDENTIALS_IN_SHARED_FLOW,
   SET_PORTAL_FLOWS,
   UPDATE_PORTAL_FLOW
} from "redux/constants/portal";

export const fetchFlows = (tenant_id) => ({
   type: FETCH_PORTAL_FLOWS,
   payload: { tenant_id }
});
export const setIsLoadingPortalFlows = (payload) => ({
   type: SET_IS_LOADING_PORTAL_FLOWS,
   payload
});
export const addPortalFlow = (payload) => ({
   type: ADD_PORTAL_FLOW,
   payload
});
export const setUserFlows = (payload) => ({
   type: SET_PORTAL_USER_FLOWS,
   payload
});
export const setOwnedSharedFlows = (payload) => ({
   type: SET_OWNED_SHARED_FLOWS,
   payload
});
export const switchView = (payload) => ({
   type: SWITCH_VIEW,
   payload
});
export const openNewFlowDialog = () => ({
   type: OPEN_NEW_FLOW_DIALOG
});
export const closeNewFlowDialog = () => ({
   type: CLOSE_NEW_FLOW_DIALOG
});
export const createNewFlow = (tenant_id, input, user, triggersAdded, cloneOptions) => ({
   type: CREATE_NEW_FLOW_FROM_PORTAL,
   payload: { tenant_id, input },
   user,
   triggersAdded,
   cloneOptions
});
export const fetchWorkflowActivities = (tenant_id, user_id) => ({
   type: FETCH_WORKFLOW_ACTIVITIES,
   payload: { tenant_id, user_id }
});
export const fetchAnalyticsActivities = (tenant_id) => ({
   type: FETCH_ANALYTICS_ACTIVITIES,
   payload: { tenant_id }
});
export const fetchUserFlows = (tenant_id) => ({
   type: FETCH_PORTAL_USER_FLOWS,
   payload: { tenant_id }
});
export const shareFlow = (tenant_id, toShareFlows, flow) => ({
   type: SHARE_PORTAL_FLOW,
   payload: { tenant_id, toShareFlows, flow }
});
export const openSharerFlowDialog = () => ({
   type: OPEN_SHARER_FLOW_DIALOG
});
export const closeSharerFlowDialog = () => ({
   type: CLOSE_SHARER_FLOW_DIALOG
});
export const openShareeFlowDialog = () => ({
   type: OPEN_SHAREE_FLOW_DIALOG
});
export const closeShareeFlowDialog = () => ({
   type: CLOSE_SHAREE_FLOW_DIALOG
});
export const setCredentialsInSharedFlow = (payload) => ({
   type: SET_CREDENTIALS_IN_SHARED_FLOW,
   payload
});
export const setPortalFlows = (payload) => ({
   type: SET_PORTAL_FLOWS,
   payload
});
export const updatePortalFlow = (payload) => ({
   type: UPDATE_PORTAL_FLOW,
   payload
});
